import React from 'react'
import { Helmet } from 'react-helmet'

const title = `
  Glumail - the dynamic email evolution
`

const description = `
  Hecho a partir de Google AMP Mail Glumail permite el envío de una nueva generación de emails, más ricos,
  interactivos e hiperconectados.
`

const keywords = `
  Glumail, amp, mails interactivos, nueva generación de emails, Google AMP, AMP, mails dinámicos, email
`
export const Metas = () => (
  <React.Fragment>
    <Helmet
      title={title}
      meta={[
        {
          name: 'description',
          content: description
        }, {
          name: 'keywords',
          content: keywords
        }, {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'
        }, {
          property: 'og:title',
          content: title
        }, {
          property: 'og:type',
          content: 'website'
        }, {
          property: 'og:url',
          content: 'https://glumail.com'
        }, {
          property: 'og:image',
          content: 'https://glumail.com/images/og-image.jpg'
        }, {
          property: 'og:image:width',
          content: '1200'
        }, {
          property: 'og:image:height',
          content: '630'
        }, {
          property: 'og:description',
          content: description
        }, {
          name: 'twitter:card',
          content: 'summary'
        }
      ]}
    />
  </React.Fragment>
)

export default Metas
